/* =======================================================================
   Doughs — Blocco "Impasti speciali" (compare in Home e in fondo al Menù)
   =======================================================================
   I 6 impasti sono in src/data/copy.js → sezione "doughs" → array "list".
   La nota "tutti gli impasti speciali +€ 1,50" è in "doughs" → "note".
   ======================================================================= */
import { useLang } from "@/context/LanguageContext";

export default function Doughs({ copy }) {
  const { tr } = useLang();
  return (
    <section
      id="impasti"
      data-testid="doughs"
      className="bg-[#2C2C2A] text-[#F7F4EB] py-24 lg:py-36 relative overflow-hidden"
    >
      <div
        className="absolute inset-0 opacity-[0.06] pointer-events-none"
        style={{
          backgroundImage:
            "url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='200' height='200'><filter id='n'><feTurbulence type='fractalNoise' baseFrequency='0.85' numOctaves='2'/></filter><rect width='200' height='200' filter='url(%23n)'/></svg>\")",
        }}
      />
      <div className="relative mx-auto max-w-[1400px] px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-10 items-end mb-16">
          <div className="lg:col-span-7">
            <p className="text-[0.72rem] tracking-[0.32em] uppercase text-[#E6C9A8] mb-6">
              — {tr(copy.doughs.overline)}
            </p>
            <h2 className="font-serif font-light text-[clamp(2.4rem,5vw,4.4rem)] leading-[1.02] tracking-tight">
              {tr(copy.doughs.title)}
            </h2>
          </div>
          <div className="lg:col-span-5 lg:pl-10">
            <p className="text-sm leading-relaxed font-light text-[#EDE6D6]/85 border-l border-[#E6C9A8]/40 pl-5 italic">
              {tr(copy.doughs.note)}
            </p>
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-x-12 gap-y-10">
          {copy.doughs.list.map((d, i) => (
            <div
              key={i}
              data-testid={`dough-${i}`}
              className="border-t border-[#F7F4EB]/15 pt-6 group"
            >
              <div className="flex items-baseline justify-between mb-3">
                <h3 className="font-serif text-2xl lg:text-3xl italic">{tr(d.name)}</h3>
                <span className="font-handwriting text-2xl text-[#E6C9A8]">
                  {String(i + 1).padStart(2, "0")}
                </span>
              </div>
              <p className="text-[0.95rem] font-light leading-relaxed text-[#EDE6D6]/85">
                {tr(d.body)}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
